import React from 'react';
import { Container } from 'react-bootstrap';
import { BiSearchAlt } from 'react-icons/bi';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 2rem;
`;

const NotFoundIcon = styled.div`
  font-size: 6rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 1.5rem;
  opacity: 0.8;
`;

const NotFoundText = styled.h2`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
  margin: 0;
`;

const ArticleNotFound = () => {
  return (
    <Container>
      <NotFoundContainer>
        <NotFoundIcon>
          <BiSearchAlt />
        </NotFoundIcon>
        <NotFoundText>המאמר לא נמצא</NotFoundText>
      </NotFoundContainer>
    </Container>
  );
};

export default ArticleNotFound;
